import { useLocalStorage } from '@repo/ui/hooks'
import { ReactNode } from 'react'
import { useSelector } from 'react-redux'

import { WidgetsContext } from '@/components/dashboard/widgets/context'
import { selectDashboardWidgets } from '@/store/dashboard-widgets/selectors'
import { defaultWidget } from '@/store/dashboard-widgets/slice'
import { DashboardWidget } from '@/store/dashboard-widgets/types'
import { useStoreState } from '@/store/hooks'

export function WidgetsProvider({ children }: { children: ReactNode }) {
  const organizationId = useStoreState((state) => state.user.currentOrganizationId)
  const [savedWidgetIds, setSavedWidgetIds] = useLocalStorage<string[]>(
    `dashboardWidgetIds_${organizationId}`,
    [defaultWidget.filterTemplate.id],
  )
  const widgets = useSelector(selectDashboardWidgets)
  const reorderedWidgets = savedWidgetIds
    .map((id) => widgets.find((widget) => widget.filterTemplate.id === id))
    .filter((widget): widget is DashboardWidget => !!widget)
  return (
    <WidgetsContext.Provider value={{ savedWidgetIds, setSavedWidgetIds, reorderedWidgets }}>
      {children}
    </WidgetsContext.Provider>
  )
}
